import { useState } from 'react';
import { Play } from 'lucide-react';

const getYouTubeId = (url) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  return match ? match[1] : null;
};

const TrainerVideoEmbed = ({ url, caption }) => {
  const [playing, setPlaying] = useState(false);
  const videoId = getYouTubeId(url);

  if (!videoId) return null;

  return (
    <div className="max-w-3xl mx-auto">
      {caption && (
        <p className="text-[var(--text-main)] text-center mb-6 leading-relaxed">{caption}</p>
      )}
      <div className="relative w-full aspect-video bg-[var(--surface)] border border-[var(--border)] overflow-hidden">
        {playing ? (
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title={caption || 'Trainer Q&A video'}
            allow="accelerate-compute; autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            className="group relative w-full h-full"
            aria-label="Play trainer video"
          >
            <img
              src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
              alt={caption || 'Trainer video thumbnail'}
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-200 flex items-center justify-center">
              <div className="w-16 h-16 rounded-full bg-[var(--primary)]/90 flex items-center justify-center group-hover:scale-105 transition-transform duration-200">
                <Play className="w-7 h-7 text-black ml-1" fill="black" />
              </div>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default TrainerVideoEmbed;
